export default __webpack_public_path__ + "maps-examples-multiple-images-960-dd883361ec938d568b3c88fe8bcbcd8a.webp";